import { render, staticRenderFns } from "./ExpensePermissionCreateEdit.vue?vue&type=template&id=4d360007&scoped=true&"
import script from "./ExpensePermissionCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ExpensePermissionCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExpensePermissionCreateEdit.vue?vue&type=style&index=0&id=4d360007&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d360007",
  null
  
)

export default component.exports